/*
 * Per-bidder watchlist (favorites), persisted in localStorage so it survives
 * logout/login and tab closes on the same device. Keyed by bidder number, so
 * two guests sharing a device keep separate lists.
 *
 * Client-side only for the pilot — a guest bids from one phone. To sync across
 * devices later, back this with a `favorites` table + endpoints in the PHP API.
 */

function storageKey(bidNumber: number | null): string {
	return "eball_watchlist_" + (bidNumber != null ? bidNumber : "anon");
}

const watchlist = {
	list(bidNumber: number | null): number[] {
		try {
			const raw = localStorage.getItem(storageKey(bidNumber));
			const parsed = raw ? JSON.parse(raw) : [];
			return Array.isArray(parsed) ? parsed : [];
		} catch (e) {
			return [];
		}
	},

	has(bidNumber: number | null, itemNumber: number): boolean {
		return watchlist.list(bidNumber).indexOf(itemNumber) !== -1;
	},

	add(bidNumber: number | null, itemNumber: number): number[] {
		const current = watchlist.list(bidNumber);

		if (current.indexOf(itemNumber) === -1) {
			current.push(itemNumber);
			try {
				localStorage.setItem(storageKey(bidNumber), JSON.stringify(current));
			} catch (e) {
				// Storage unavailable — favorites just won't persist.
			}
		}

		return current;
	},

	toggle(bidNumber: number | null, itemNumber: number): number[] {
		const current = watchlist.list(bidNumber);
		const index = current.indexOf(itemNumber);

		if (index === -1) current.push(itemNumber);
		else current.splice(index, 1);

		try {
			localStorage.setItem(storageKey(bidNumber), JSON.stringify(current));
		} catch (e) {
			// Storage unavailable (private mode, quota) — favorites just won't persist.
		}

		return current;
	},
};

export default watchlist;
